import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "group flex shrink-0 items-center gap-2 whitespace-nowrap text-base font-semibold tracking-[0.08px] text-[color:var(--en-breadcrumb-muted,var(--en-blue-300))] last:text-white" };
const _hoisted_2 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("li", _hoisted_1, [
        ($setup.isExternalUrl($setup.props.breadcrumb.to))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: $setup.props.breadcrumb.to,
                class: "text-inherit no-underline transition-colors hover:text-white"
            }, _toDisplayString($setup.props.breadcrumb.text), 9 /* TEXT, PROPS */, _hoisted_2))
            : ($setup.props.breadcrumb.to)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    to: $setup.props.breadcrumb.to,
                    class: "text-inherit no-underline transition-colors hover:text-white"
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.props.breadcrumb.text), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString($setup.props.breadcrumb.text), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */)),
        _createVNode($setup["EnIcon"], {
            class: "shrink-0 group-last:hidden",
            icon: "mdi-chevron-right",
            size: "16"
        })
    ]));
}
